import { render, staticRenderFns } from "./CardOverflow.vue?vue&type=template&id=47f2361d&scoped=true&"
import script from "./CardOverflow.vue?vue&type=script&lang=js&"
export * from "./CardOverflow.vue?vue&type=script&lang=js&"
import style0 from "./CardOverflow.vue?vue&type=style&index=0&id=47f2361d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f2361d",
  null
  
)

export default component.exports